/* eslint-disable max-len */
import {
    createContext, useContext,
} from 'react'

export type SkyNetObjectProfileContextType = {
    page: number,
    setPage: (page: number) => void,
}

export const SkyNetObjectProfileContext = createContext<SkyNetObjectProfileContextType | undefined>(undefined)

const useSkyNetObjectProfileContext = () => {
    return useContext<SkyNetObjectProfileContextType| undefined>(SkyNetObjectProfileContext)
}

export default useSkyNetObjectProfileContext
